import { baseURL } from "./_common";

export default [
  {
    // INFO 1
    id: 501,
    type: "info",
    title: "Info About",
    template: "block-info1",
    hasScript: false,
    firebase: false,
    required: [],
    options: {
      bg: {
        color: "#ffffff"
      },
      categoryTitle: {
        text: "Culture",
        colorTheme: "g-color--primary"
      },
      title: {
        text: "About <br> Cortexial",
        colorTheme: "g-color--base"
      },
      subtitle: {
        text:
          "We aim high at being focused on building relationships with our clients and community. Using our creative gifts drives this foundation. The time has come to bring those ideas and plans to life. This is where we really begin to visualize your napkin sketches and make them into beautiful pixels.<br><br>Now that your brand is all dressed up and ready to party, it's time to release it to the world. By the way, let's celebrate already.",
        colorTheme: "g-color--base"
      },
      image: {
        url: `${baseURL}/static/templates/theme1/img/970/01.jpg`
      }
    },
    settings: [
      { el: "image", title: "Image URL", type: "image" },
      { el: "bg.color", title: "Background Color", type: "color" },
      {
        el: "categoryTitle.colorTheme",
        title: "Category Title Color",
        type: "colorTheme"
      },
      { el: "title.colorTheme", title: "Title Color", type: "colorTheme" },
      {
        el: "subtitle.colorTheme",
        title: "Subtitle Color",
        type: "colorTheme"
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/util/blockTemplatesInfo.js